import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
export function Hero() {
  return <section className="min-h-[100svh] flex items-center pt-4 pb-6 md:pt-20 md:pb-24 px-4" data-id="element-72">
      <div className="max-w-4xl mx-auto text-center w-full" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-74">
          {/* Audience pill */}
          <div className="inline-block bg-brand-teal/10 text-brand-teal font-semibold px-3 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] leading-tight md:text-sm mb-3 md:mb-8 uppercase tracking-wider" data-id="element-75">
            Para kinesiólogos que recién comienzan y los que sienten que les
            falta estructura
          </div>

          {/* Big headline */}
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold text-brand-charcoal leading-[1.05] mb-2 md:mb-6 uppercase tracking-tight" data-id="element-76">
            Si eres kinesiólogo/a y todavía buscas material clínico la noche
            anterior a la sesión...
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto mb-3 md:mb-10 leading-relaxed" data-id="element-77">
            Esto es para ti.
          </p>
        </motion.div>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="my-3 md:my-12 flex justify-center" data-id="element-78">
          <div onClick={scrollToCompra} className="cursor-pointer group relative max-w-[14rem] sm:max-w-sm md:max-w-3xl w-full" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/nyJUwhpcUjzLFM2d8gCo44/8d4d8fef-fb52-4928-aafd-34ffdfed2053-removebg-preview.png" alt="MEGA PACK KINESIOLOGÍA — Sistema clínico completo: 18 tomos clínicos + 5 bonos incluidos" className="w-full h-auto transition-transform duration-500 group-hover:scale-[1.02]" data-id="element-80" />
          </div>
        </motion.div>

        {/* Bullets */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-xl mx-auto mb-3 md:mb-8" data-id="element-81">
          <ul className="space-y-1.5 md:space-y-4 text-left inline-block" data-id="element-82">
            <li className="flex items-start gap-3 text-gray-700 text-sm md:text-lg" data-id="element-83">
              <Check className="text-brand-teal flex-shrink-0 mt-0.5 md:mt-1" size={18} strokeWidth={3} data-id="element-84" />
              <span data-id="element-85">
                <span className="font-semibold text-brand-charcoal" data-id="element-86">
                  18 tomos clínicos + 5 bonos incluidos.
                </span>
                <span className="block text-xs md:text-base text-gray-500 mt-0.5" data-id="element-87">
                  Traumatología, columna, neuro, respiratoria, deportiva,
                  pediátrica y más.
                </span>
              </span>
            </li>
            <li className="flex items-start gap-3 text-gray-700 text-sm md:text-lg" data-id="element-88">
              <Check className="text-brand-teal flex-shrink-0 mt-0.5 md:mt-1" size={18} strokeWidth={3} data-id="element-89" />
              <span data-id="element-90">
                <span className="font-semibold text-brand-charcoal" data-id="element-91">
                  Protocolos listos para usar desde mañana.
                </span>
                <span className="block text-xs md:text-base text-gray-500 mt-0.5" data-id="element-92">
                  Evaluación, plan de tratamiento, progresiones y criterios de
                  alta.
                </span>
              </span>
            </li>
            <li className="flex items-start gap-3 text-gray-700 text-sm md:text-lg" data-id="element-93">
              <Check className="text-brand-teal flex-shrink-0 mt-0.5 md:mt-1" size={18} strokeWidth={3} data-id="element-94" />
              <span data-id="element-95">
                <span className="font-semibold text-brand-charcoal" data-id="element-96">
                  Adaptado a la práctica clínica.
                </span>
                <span className="block text-xs md:text-base text-gray-500 mt-0.5" data-id="element-97">
                  Seguros médicos, honorarios, lenguaje clínico y contextos
                  reales.
                </span>
              </span>
            </li>
          </ul>
        </motion.div>

        {/* Tagline */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-base md:text-xl text-brand-charcoal font-medium mb-4 md:mb-8" data-id="element-98">
          Descargas. Imprimes. Llegas a cada sesión con un plan claro.
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-99">
          <button onClick={scrollToCompra} className="inline-flex items-center justify-center gap-3 bg-brand-teal hover:bg-brand-dark text-white font-bold py-4 px-8 md:py-5 md:px-10 rounded-xl shadow-[0_10px_30px_rgb(15,118,110,0.35)] hover:shadow-[0_10px_40px_rgb(15,118,110,0.5)] transition-all transform hover:-translate-y-0.5 text-base md:text-lg uppercase tracking-wide w-full max-w-md" data-id="element-100">
            Quiero el Mega Pack ahora
            <ArrowRight size={20} data-id="element-101" />
          </button>
          <p className="text-xs md:text-sm text-gray-500 mt-3 md:mt-4" data-id="element-102">
            Pago único de $27 USD · Acceso inmediato · Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}